<template>
<div class="chapter">
<div class="inner_page">
      ﻿


	
		<title>hom01eFM.html</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<div id="hom01efm">
<div class="generated-style">
<p class="centered"><img alt="Haunting of Mississippi display text.tif" src="images/HauntingofMississip_fmt2.jpeg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// hom01eHT2.vue?26c35b80